export default "__VITE_ASSET__BzKcUjJC__"